import React from "react";
import { Dialog, DialogContent, makeStyles, useTheme } from "@material-ui/core";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { CreateCliente } from "../create/formCreateCliente";
import { EditCliente } from "../edit/formEditCliente";
const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
}));
export const ModalClientes = ({ busqueda, rowsPerPage, setopenMondal, isOpen, isEdit, data, reload, editUser }) => {
    const clearData = () => {
        setopenMondal(false);
    };
    const classes = useStyles();
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }}className={classes.title} style={{color:primaryColor}}>
                        {isEdit ? `Editar Cliente` : `Crear Cliente`}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        {isEdit ? (
                            <EditCliente
                                data={data}
                                clearData={clearData}
                                reload={reload}
                                handleCloseModal={clearData} // Pasa la función para cerrar la modal
                                primaryColor={primaryColor}
                            />
                        ) : (
                            <CreateCliente
                                create={reload}
                                clearData={clearData}
                                handleCloseModal={clearData} // Pasa la función para cerrar la modal
                            />
                        )}
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
};
